var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 12H20.0133M20 20C24.4183 20 28 16.4183 28 12C28 7.58172 24.4183 4 20 4C15.5817 4 12 7.58172 12 12C12 12.3649 12.0244 12.7241 12.0717 13.0761C12.1496 13.6549 12.1885 13.9444 12.1623 14.1275C12.135 14.3183 12.1003 14.4209 12.0063 14.5892C11.916 14.7507 11.7569 14.9097 11.4388 15.2279L4.62484 22.0419C4.39424 22.2724 4.27893 22.3877 4.19648 22.5223C4.12337 22.6416 4.06951 22.7716 4.03684 22.9077C4 23.0612 4 23.2243 4 23.5503V25.8667C4 26.6135 4 26.9868 4.14532 27.272C4.27316 27.5229 4.47713 27.7268 4.72801 27.8547C5.01323 28 5.3866 28 6.13333 28H8.44968C8.7758 28 8.93885 28 9.09231 27.9632C9.22836 27.9305 9.35841 27.8767 9.47771 27.8035C9.61227 27.7211 9.72757 27.6057 9.95817 27.3752L16.7721 20.5612C17.0903 20.2431 17.2493 20.084 17.4108 19.9937C17.5791 19.8997 17.6817 19.8649 17.8725 19.8377C18.0556 19.8115 18.3451 19.8504 18.924 19.9283C19.2759 19.9756 19.6351 20 20 20Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.43f10da28598f051d35d233f7af34d13.svg";
export { ForwardRef as ReactComponent };